import React, { useRef } from "react";

const Question = ({gameState, activeQuesitonIndex, exercisesArr, handleUserSubmit}:{gameState:string, activeQuesitonIndex:number, exercisesArr:string[], handleUserSubmit:Function}) => {

	var submitEnabled = (gameState !== 'runningExercise') ? false : true;
	const inputValue = useRef('');
	const inputElement:any = useRef(null);
	function handleInputChange(e:React.ChangeEvent<HTMLInputElement>) {
		inputValue.current = e.target.value;
	}

	function onkeydown(event:React.KeyboardEvent<HTMLInputElement>) {
		if (submitEnabled && event.key === 'Enter') {
			handleUserSubmit(inputElement.current.value);
			inputElement.current.value = '';
		}
	}
	function handleButtonDown(number:string){
		//var number:string =  e.target.innerText;
		if (!submitEnabled) {
			return;
		}		
		console.log(number);
		inputElement.current.value += number;
	}
	function clearInput() {
		inputElement.current.value = '';
	}
	function backspaceInput() {
		inputElement.current.value = inputElement.current.value.substring(0, inputElement.current.value.length-1);
		console.log(inputElement.current.value);
	}

	console.log('ttt',document.documentElement.ontouchstart);
	return(
		<>
			<div  className="d-flex flex-column" style={{textAlign:'center'}}>
				{gameState === 'runningExercise' &&
					<h2>{exercisesArr[activeQuesitonIndex].split('=')[0]}</h2>
				}
				<div id="answer" className="d-flex justify-content-center">
					<button onClick={clearInput} className="btn btn-warning" style={{width:'50px', height:'40px', borderTopRightRadius:'0px', borderBottomRightRadius:'0px'}}>
						C
					</button>

					<input onKeyDown={onkeydown} type="text" disabled={(document.documentElement.ontouchstart !== undefined) ? true : false} onChange={handleInputChange} autoFocus style={{borderRadius:'0px',width:'80px', height:'40px', textAlign:'center', fontSize:'24px'}}
						ref = {inputElement}
						/*ref = {(inp) => {
							if (inp) {
								inp.value='';
							}
							//inp?.focus();
						 }}*/
					/>

					<button onClick={backspaceInput} className="btn btn-secondary d-flex justify-content-center align-items-center" style={{width:'50px', height:'40px', borderTopLeftRadius:'0px', borderBottomLeftRadius:'0px'}}>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-backspace" viewBox="0 0 16 16">
							<path d="M5.83 5.146a.5.5 0 0 0 0 .708L7.975 8l-2.147 2.146a.5.5 0 0 0 .707.708l2.147-2.147 2.146 2.147a.5.5 0 0 0 .707-.708L9.39 8l2.146-2.146a.5.5 0 0 0-.707-.708L8.683 7.293 6.536 5.146a.5.5 0 0 0-.707 0z"/>
							<path d="M13.683 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7.08a2 2 0 0 1-1.519-.698L.241 8.65a1 1 0 0 1 0-1.302L5.084 1.7A2 2 0 0 1 6.603 1zm-7.08 1a1 1 0 0 0-.76.35L1 8l4.844 5.65a1 1 0 0 0 .759.35h7.08a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"/>
						</svg>
					</button>
				</div>
				<div  id="touchPad" className="d-flex flex-row mt-4 mb-3" style={{justifyContent:'center'}}>
					<div className="d-flex flex-column" >
						<button onMouseDown={()=>{handleButtonDown('7')}} className="btn btn-light boxBorder">7</button>
						<button onMouseDown={()=>{handleButtonDown('4')}} className="btn btn-light boxBorder">4</button>
						<button onMouseDown={()=>{handleButtonDown('1')}} className="btn btn-light boxBorder">1</button>
						<button className="btn btn-light boxBorder" disabled></button>
					</div>
					<div className="d-flex flex-column " >
						<button onMouseDown={()=>{handleButtonDown('8')}} className="btn btn-light boxBorder">8</button>
						<button onMouseDown={()=>{handleButtonDown('5')}} className="btn btn-light boxBorder">5</button>
						<button onMouseDown={()=>{handleButtonDown('2')}} className="btn btn-light boxBorder">2</button>
						<button onMouseDown={()=>{handleButtonDown('0')}} className="btn btn-light boxBorder">0</button>
					</div>
					<div  className="d-flex flex-column " >
						<button onMouseDown={()=>{handleButtonDown('9')}} className="btn btn-light boxBorder">9</button>
						<button onMouseDown={()=>{handleButtonDown('6')}} className="btn btn-light boxBorder">6</button>
						<button onMouseDown={()=>{handleButtonDown('3')}} className="btn btn-light boxBorder">3</button>
						<button className="btn btn-light boxBorder" disabled></button>
					</div>
				</div>
				<div>
					<button onClick={()=>{handleUserSubmit(inputElement.current.value);inputElement.current.value = ''; inputElement.current.focus()}} className="btn btn-success mb-2" disabled={!submitEnabled}>SUBMIT</button>
				</div>
			</div>
		</>
	)
}



export default Question;